module.exports = __webpack_public_path__ + "media/images/prize__xt-brakeset-ceadf0dbc51c353f36e078805e3eff38.jpg";